import messages from '@smartmixin/i18n/dist/translations/ca.json';

export default messages;
